import { SC } from "../helper/ServerCall";

export const testimonialService = {
    getTestimonials,
    storeTestimonial,
    deleteTestimonial,
    approveByToken
}

function getTestimonials(brand_id, pageSize, sort, filter, is_admin) {
    return SC.getCall(`testimonial?brand=${brand_id}&pageSize=${pageSize}&sort=${sort}&filter=${filter}&is_admin=${is_admin}`);
}

function storeTestimonial(data) {
    return SC.postCallWithoutAuth('testimonial', data);
}

function deleteTestimonial(id) {
    return SC.deleteCall(`deleteTestimonial/${id}`)
}
function approveByToken(token) {
    return SC.putCall(`testimonial/approve/${token}`);
}